/**
 * FX 确定性伪随机数工具
 *
 * <p>提供 mulberry32 确定性 PRNG（同种子同序列）与 Box-Muller 正态分布采样，
 * 用于前端本地生成全端一致的模拟行情。</p>
 */

/**
 * 创建 mulberry32 状态化随机数生成器
 *
 * <p>支持保存/恢复内部状态，便于行情序列增量续算。</p>
 *
 * @param {number} seed 32 位无符号整数种子
 * @returns {{next: function, getState: function, setState: function}} 生成器对象
 */
export function createGenerator(seed) {
	let a = seed >>> 0
	return {
		/**
		 * 生成下一个 [0,1) 均匀随机数
		 *
		 * @returns {number} [0,1) 区间随机数
		 */
		next() {
			a |= 0
			a = (a + 0x6D2B79F5) | 0
			let t = Math.imul(a ^ (a >>> 15), 1 | a)
			t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
			return ((t ^ (t >>> 14)) >>> 0) / 4294967296
		},
		/**
		 * 获取当前内部状态
		 *
		 * @returns {number} 内部状态整数
		 */
		getState() {
			return a
		},
		/**
		 * 恢复内部状态
		 *
		 * @param {number} state 内部状态整数
		 */
		setState(state) {
			a = state >>> 0
		}
	}
}

/**
 * 生成标准正态分布随机数（Box-Muller）
 *
 * <p>每调用一次消耗生成器两个随机数。</p>
 *
 * @param {object} gen mulberry32 生成器
 * @returns {number} 标准正态分布随机数
 */
export function nextNormal(gen) {
	let u = 0
	let v = 0
	while (u === 0) u = gen.next()
	while (v === 0) v = gen.next()
	const mag = Math.sqrt(-2.0 * Math.log(u))
	return mag * Math.cos(2.0 * Math.PI * v)
}
